// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin {
  font-size: 16px;

  .table-responsive {
    overflow-x: auto;
    max-width: 100%;
    -webkit-overflow-scrolling: touch; /* スムーズなスクロールを有効化 */
    margin-bottom: 1rem; /* スクロールバーとの間に余白を作る */
    box-sizing: border-box; /* スクロールバーを考慮したボックスサイズ */
  }
  
  .price-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; /* テーブルの列幅を固定する */
    word-wrap: break-word; /* 単語の途中で改行 */
    overflow-wrap: break-word; /* 長い単語を折り返す */
    white-space: nowrap; /* 全セルのテキストを一行で表示 */
  }
  
  .price-table th, .price-table td {
    border: 1px solid #ddd;
    padding: 8px;
    vertical-align: middle; /* セルの上下中央に表示 */
    text-align: left;
    word-wrap: break-word; /* 単語の途中で改行 */
    overflow-wrap: break-word; /* 長い単語を折り返す */
  }
  
  .price-table th {
    background-color: #f4f4f4;
    position: sticky;
    top: 0;
    z-index: 2;
    white-space: nowrap; /* ヘッダー内のテキストが改行されないようにする */
  }
  
  .price-table .course-name-header,
  .price-table .course-name {
    position: sticky;
    left: 0;
    background-color: #f4f4f4;
    z-index: 3;
    max-width: 20vw;
    min-width: 20vw;
    width: 20vw;
  }
  
  .price-table tr > td {
    border-top: 1px solid #aaa; /* 線を濃く設定 */
    vertical-align: top; /* 上揃えにして、内容が多い場合でも整列 */
  }
  
  .price-table tr:first-child > td {
    border-top: none; /* 最初の行には適用しない */
  }
  
  .price-table .feature-header,
  .price-table .feature-cell {
    max-width: 70vw; /* 特徴のカラムの最大幅を設定 */
    width: 70vw; 
    min-width: 30vw; /* 特徴のカラムの最小幅を設定 */
  }
  
  .price-table .available-cell {
    max-width: 30vw; /* 特徴のカラムの最大幅を設定 */
    width: 30vw; 
    min-width: 30vw; /* 特徴のカラムの最小幅を設定 */
  }
  
  @media (max-width: 767px) {
    .table-responsive {
      overflow-x: auto;
      max-width: 100%;
    }

    .price-table {
      width: 100%;
      table-layout: auto;
    }

    .price-table .feature-cell {
      min-width: 70vw;
    }

    .price-table th, .price-table td {
      font-size: 0.875rem;
      padding: 4px;
    }
  }
  
  .text-right {
    text-align: right !important;
  }
  
  .text-center {
    text-align: center !important;
  }
  
  /* コース名やその他のカラムがセル内に収まるように行の高さを自動調整 */
  .price-table td {
    vertical-align: top; /* セルの上下中央ではなく、上揃えにする */
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.5;
    white-space: normal; /* テキストがはみ出さないようにする */
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/priceTableAll.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;EAEf;IACE,gBAAgB;IAChB,eAAe;IACf,iCAAiC,EAAE,mBAAmB;IACtD,mBAAmB,EAAE,qBAAqB;IAC1C,sBAAsB,EAAE,wBAAwB;EAClD;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAE,iBAAiB;IACtC,qBAAqB,EAAE,aAAa;IACpC,yBAAyB,EAAE,cAAc;IACzC,mBAAmB,EAAE,mBAAmB;EAC1C;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB,EAAE,eAAe;IACvC,gBAAgB;IAChB,qBAAqB,EAAE,aAAa;IACpC,yBAAyB,EAAE,cAAc;EAC3C;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;;IAEE,gBAAgB;IAChB,OAAO;IACP,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0BAA0B,EAAE,WAAW;IACvC,mBAAmB,EAAE,uBAAuB;EAC9C;;EAEA;IACE,gBAAgB,EAAE,gBAAgB;EACpC;;EAEA;;IAEE,eAAe,EAAE,kBAAkB;IACnC,WAAW;IACX,eAAe,EAAE,kBAAkB;EACrC;;EAEA;IACE,eAAe,EAAE,kBAAkB;IACnC,WAAW;IACX,eAAe,EAAE,kBAAkB;EACrC;;EAEA;IACE;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,mBAAmB;MACnB,YAAY;IACd;EACF;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,qCAAqC;EACrC;IACE,mBAAmB,EAAE,uBAAuB;IAC5C,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB,EAAE,qBAAqB;EAC5C;AACF","sourcesContent":[".elt-wp-plugin {\n  font-size: 16px;\n\n  .table-responsive {\n    overflow-x: auto;\n    max-width: 100%;\n    -webkit-overflow-scrolling: touch; /* スムーズなスクロールを有効化 */\n    margin-bottom: 1rem; /* スクロールバーとの間に余白を作る */\n    box-sizing: border-box; /* スクロールバーを考慮したボックスサイズ */\n  }\n  \n  .price-table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed; /* テーブルの列幅を固定する */\n    word-wrap: break-word; /* 単語の途中で改行 */\n    overflow-wrap: break-word; /* 長い単語を折り返す */\n    white-space: nowrap; /* 全セルのテキストを一行で表示 */\n  }\n  \n  .price-table th, .price-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    vertical-align: middle; /* セルの上下中央に表示 */\n    text-align: left;\n    word-wrap: break-word; /* 単語の途中で改行 */\n    overflow-wrap: break-word; /* 長い単語を折り返す */\n  }\n  \n  .price-table th {\n    background-color: #f4f4f4;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    white-space: nowrap; /* ヘッダー内のテキストが改行されないようにする */\n  }\n  \n  .price-table .course-name-header,\n  .price-table .course-name {\n    position: sticky;\n    left: 0;\n    background-color: #f4f4f4;\n    z-index: 3;\n    max-width: 20vw;\n    min-width: 20vw;\n    width: 20vw;\n  }\n  \n  .price-table tr > td {\n    border-top: 1px solid #aaa; /* 線を濃く設定 */\n    vertical-align: top; /* 上揃えにして、内容が多い場合でも整列 */\n  }\n  \n  .price-table tr:first-child > td {\n    border-top: none; /* 最初の行には適用しない */\n  }\n  \n  .price-table .feature-header,\n  .price-table .feature-cell {\n    max-width: 70vw; /* 特徴のカラムの最大幅を設定 */\n    width: 70vw; \n    min-width: 30vw; /* 特徴のカラムの最小幅を設定 */\n  }\n  \n  .price-table .available-cell {\n    max-width: 30vw; /* 特徴のカラムの最大幅を設定 */\n    width: 30vw; \n    min-width: 30vw; /* 特徴のカラムの最小幅を設定 */\n  }\n  \n  @media (max-width: 767px) {\n    .table-responsive {\n      overflow-x: auto;\n      max-width: 100%;\n    }\n\n    .price-table {\n      width: 100%;\n      table-layout: auto;\n    }\n\n    .price-table .feature-cell {\n      min-width: 70vw;\n    }\n\n    .price-table th, .price-table td {\n      font-size: 0.875rem;\n      padding: 4px;\n    }\n  }\n  \n  .text-right {\n    text-align: right !important;\n  }\n  \n  .text-center {\n    text-align: center !important;\n  }\n  \n  /* コース名やその他のカラムがセル内に収まるように行の高さを自動調整 */\n  .price-table td {\n    vertical-align: top; /* セルの上下中央ではなく、上揃えにする */\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    line-height: 1.5;\n    white-space: normal; /* テキストがはみ出さないようにする */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
